import script from "./BowlerEditableInfoForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./BowlerEditableInfoForm.vue?vue&type=script&lang=ts&setup=true"

import "./BowlerEditableInfoForm.vue?vue&type=style&index=0&id=70da4c07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70da4c07"]])

export default __exports__